import { Alert, AlertDescription, AlertTitle } from '@reflex/ui/components/ui/alert';

/**
 * Shown when a user lands inside an un-bootstrapped organization but
 * doesn't have permission to walk the phase 2 wizard themselves.
 */
export function WaitingForOwner({ orgName }: { orgName: string }) {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-background px-4">
      <Alert className="max-w-md">
        <AlertTitle>Waiting for setup</AlertTitle>
        <AlertDescription>
          <strong>{orgName}</strong> hasn't finished initial setup yet. An organization owner needs
          to complete the org-setup wizard before this workspace becomes available.
        </AlertDescription>
      </Alert>
    </div>
  );
}
